import { handleDataInvoice } from '@/utils/invoice';
import BaseProxy from '../base-proxy';
import Vue from 'vue';

/**
 * Class EInvoiceProxy
 */
class EInvoiceProxy extends BaseProxy {
  /**
   * Constructor.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super('/e-invoice-api/api/invoices', parameters);
    this.defaultOptions = { allowToast: false };
  }

  createEInvoice(payload, options = {}) {
    const data = handleDataInvoice(payload);
    return this.submit('post', `${this.endpoint}/create`, data, { ...this.defaultOptions, ...options });
  }

  getEInvoice(id, options = {}) {
    return this.submit('get', `${this.endpoint}/${id}`, null, { ...this.defaultOptions, ...options });
  }

  updateEInvoice(payload, options = {}) {
    const { id, ...data } = handleDataInvoice(payload);
    return this.submit('put', `${this.endpoint}/update/${id}`, data, { ...this.defaultOptions, ...options });
  }

  getMistakeReports(options = {}) {
    return this.submit('get', `${this.endpoint}/mistake-reports`, null, { ...this.defaultOptions, showResponseStatus: true, ...options });
  }

  sendEmailPreview(payload, options = {}) {
    return this.submit('post', `${this.endpoint}/send-email-preview`, payload, { ...this.defaultOptions, ...options });
  }

  downloadXmlBcssHistory(payload, options = {}) {
    const { id, nameFile, typeFile } = payload;
    return new Promise((resolve, reject) => {
      this.submit('get', `${this.endpoint}/download-xml-bcss-history/${id}`, null, {
        ...this.defaultOptions,
        responseType: 'blob',
        ...options,
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${nameFile}.${typeFile}`);
        document.body.appendChild(link);
        link.click();
        resolve(response);
      }).catch(e => reject(e));
    });
  }

  releaseReplaceModifyPublishedInvoice(payload, uploadStatus) {
    const formData = new FormData();
    if (payload.ca_type && payload.ca_type === 'HSM') {
      formData.append('ca_id', payload.ca_id);
      formData.append('ca_type', payload.ca_type);
    } else {
      formData.append('invoice_id', payload.id);
      formData.append('signed_xml', payload.xml);
      formData.append('signed_pdf', payload.pdf);
    }
    return this.submit('post', `${this.endpoint}/release-replace-modify/${payload.id}`, formData, {
      ...this.defaultOptions,
      onUploadProgress(progressEvent) {
        uploadStatus.percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total,
        );
      },
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }

  getListSetting(options = {}) {
    return this.submit('get', `e-invoice-api/api/seller-setting/list`, null, { ...this.defaultOptions, ...options });
  }

  updateSetting(payload, options = {}) {
    return this.submit('put', `e-invoice-api/api/seller-setting/update`, payload, { ...this.defaultOptions, ...options });
  }
}

export default EInvoiceProxy;



// WEBPACK FOOTER //
// ./src/store/proxies/e-invoice/e-invoice-proxy.js